module.exports = __webpack_public_path__ + "img/IMG_1458_L_Wood_MockedUp.0f669e59.jpg";